<template>
  <div :class="`iqos-scroll-wrapper gap-row-${barGap}`">
    <div class="iqos-horizontal-scroll" :style="{
          'height': typeof height === 'number' ? `${height}px` : height  
        }" :id="scrollerId" ref="scrollContainer">
      <div
        class="scroller"
        :class="{
          'pl-40': withPaddings,
          'pr-40': withPaddings,
        }"
        :style="{
          ...scrollContainerStyles,
          'column-gap': `${gap}px`,
        }"
      >
        <slot />
      </div>
    </div>
    <div
      :class="{
        'pl-40': withPaddings,
        'pr-40': withPaddings,
        'smart-scroll-container': true
      }"
      v-if="!noScroller"
      v-show="is_scroller_shown"
    >
      <BaseSmartScroller
        :selector="'#' + scrollerId"
        ref="smartScroller"
        :element="scrollContainerDomNode"
        @checked="shown => is_scroller_shown = shown"
        v-if="can_show_scroller"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    withPaddings: {
      type: Boolean,
      default: true,
    },
    elementCount: {
      type: Number,
    },
    noScroller: {
      type: Boolean,
      default: false,
    },
    gap: {
      type: Number,
      default: 16
    },
    height: {
      type: Number,
      default: 160
    },
    scrollContainerStyles: {
      type: Object,
      default: {}
    },
    barGap: {
      type: String,
      default: 'sm'
    }
  },
  data() {
    return {
      can_show_scroller: false,
      is_scroller_shown: false,
      scrollerId: null
    };
  },
  watch: {
    elementCount() {
      if (!this.noScroller && this.can_show_scroller)
        console.log(`Received elementCount event ${this.elementCount} for ${this.scrollerId}, updating scroller...`);
        this.$nextTick(() => {
          if (this.$refs.smartScroller)  {
            this.$refs.smartScroller.onTargetScrolled();
            console.log(`Event check complete for scroller.`)
          }
        });
    },
  },
  computed: {
    scrollContainerDomNode() {
      return this.$refs.scrollContainer;
    }
  },
  created() {
    this.scrollerId = Math.random().toString(36).slice(4);
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.can_show_scroller = true;
      }, 450);
    });
  },
};
</script>   

<style scoped>
.iqos-horizontal-scroll {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  width: auto;
  position: relative;
}

.scroller {
  display: flex;
  width: fit-content;
  height: 100%;
  box-sizing: border-box;
}
</style>